import { connect } from 'react-redux'
import { compose, mapProps } from 'recompose'
import withType from 'components/common/hoc/withType'
import { applyFilter, resetFilters } from '../../actions'
import BOTGlobalSearchBreadcrumbs from './BOTGlobalSearchBreadcrumbs'
import { getClearAllNavigationState } from '../../helpers'

const withTransformRefinementCrumbs = mapProps(({ refinementCrumbs, ...props }) => {
  const mappedRefinementCrumbs = refinementCrumbs
    .map(({ removeAction: { navigationState } = {}, ...crumbProps } = {}) => ({
      ...crumbProps,
      navigationState
    }))

  return {
    ...props,
    mappedRefinementCrumbs,
    clearAllNavigationState: getClearAllNavigationState(mappedRefinementCrumbs)
  }
})

export default compose(
  withType({ type: 'BOTGlobalSearchBreadcrumbs' }),
  connect(null, { applyFilter, resetFilters }),
  withTransformRefinementCrumbs
  // withGetClearAllNavigationState
)(BOTGlobalSearchBreadcrumbs)
